import React from 'react';

export const BatterySvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 4C24 6.209 22.209 8 20 8H16C13.791 8 12 6.209 12 4C12 1.791 13.791 0 16 0H20C22.209 0 24 1.791 24 4Z" fill={color} />
        <path fill-rule="evenodd" clipRule="evenodd" d="M26 36C28.209 36 30 34.209 30 32V8C30 5.791 28.209 4 26 4H10C7.791 4 6 5.791 6 8V32C6 34.209 7.791 36 10 36H26ZM20 14H23C23.553 14 24 14.448 24 15V17C24 17.553 23.553 18 23 18H20V21C20 21.553 19.553 22 19 22H17C16.448 22 16 21.553 16 21V18H13C12.447 18 12 17.553 12 17V15C12 14.448 12.447 14 13 14H16V11C16 10.448 16.448 10 17 10H19C19.553 10 20 10.448 20 11V14ZM12 29C12 29.553 12.447 30 13 30H23C23.553 30 24 29.553 24 29V27C24 26.447 23.553 26 23 26H13C12.447 26 12 26.447 12 27V29Z" fill={color} />
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 4C24 6.209 22.209 8 20 8H16C13.791 8 12 6.209 12 4C12 1.791 13.791 0 16 0H20C22.209 0 24 1.791 24 4Z" fill="#D2D2D2" />
      <path d="M30 32C30 34.209 28.209 36 26 36H10C7.791 36 6 34.209 6 32V8C6 5.791 7.791 4 10 4H26C28.209 4 30 5.791 30 8V32Z" fill="#E3E3E3" />
      <path d="M6 8H30V32H6V8Z" fill="#1AAA60" />
      <path d="M23 14H20V11C20 10.448 19.553 10 19 10H17C16.448 10 16 10.448 16 11V14H13C12.447 14 12 14.448 12 15V17C12 17.553 12.447 18 13 18H16V21C16 21.553 16.448 22 17 22H19C19.553 22 20 21.553 20 21V18H23C23.553 18 24 17.553 24 17V15C24 14.448 23.553 14 23 14ZM13 30C12.447 30 12 29.553 12 29V27C12 26.447 12.447 26 13 26H23C23.553 26 24 26.447 24 27V29C24 29.553 23.553 30 23 30H13Z" fill="#F5F8FA" />
    </svg>
  )
}